<router-outlet>
    <div class="bg-blur" *ngIf="loading">
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <mat-spinner [diameter]="100"></mat-spinner>
        </div>
    </div>
</router-outlet>
